export default "/images/433a6e5bfba63503a05796f679793d0c.avif";